module.exports = __webpack_public_path__ + "982a78deb3985bb471a25657def563d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/notifications/booking.png
// module id = 649
// module chunks = 0